import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { resetUnauthorized } from '~/services/session/actions';

export default function UnauthorizedRedirect() {
	const unauthorized = useSelector(state => state.session.unauthorized);
	const dispatch = useDispatch();

	if (unauthorized) {
		dispatch(resetUnauthorized());

		return <Redirect to="/403" />;
	}

	return null;
}
